import React, { useEffect } from 'react';
import { BrowserRouter as Router, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { isClientPortalUser } from './utils/isClientPortalUser';
import { defaultLandingPath } from './utils/userDashboardPermissions';
import { getUserRole } from './utils/sessionStore';
import Header from './HomePage/Header';
import AfterLoginRoutes from './Routes/AfterLoginRoutes';
import Footer from './HomePage/Fooder';
import IdleSessionGuard from './components/IdleSessionGuard';
import './App.css';

const AppWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading, isAuthenticated: authed } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname, location.search, location.key]);

  useEffect(() => {
    if (isLoading) return;

    const path = location.pathname;
    const clientUser = isClientPortalUser();
    const clientHome = defaultLandingPath(getUserRole());

    if (authed) {
      if (path === '/' || path === '/login') {
        if (clientUser) {
          navigate(clientHome);
        } else {
          navigate('/admin-dashboard');
        }
      }
      if (
        clientUser &&
        !path.startsWith('/client') &&
        !path.startsWith('/user-app') &&
        !path.startsWith('/user/subscription') &&
        path !== '/login'
      ) {
        navigate(clientHome);
      }
      if (!clientUser && path.startsWith('/client')) {
        navigate('/admin-dashboard');
      }
    } else if (path !== '/login') {
      navigate('/login');
    }
  }, [location.pathname, navigate, isLoading, authed]);

  if (isLoading) {
    return null;
  }

  const authenticated = authed;
  const clientUser = isClientPortalUser();
  const onClientRoute =
    location.pathname.startsWith('/client') ||
    location.pathname.startsWith('/user-app') ||
    location.pathname.startsWith('/user/subscription');
  const onAdminUserDashboard = location.pathname.startsWith('/admin/users/');
  const showAdminChrome =
    authenticated && !clientUser && !onClientRoute && !onAdminUserDashboard;

  return (
    <div className="app-shell">
      <IdleSessionGuard />
      {showAdminChrome && <Header />}
      <div className="app-content">
        <AfterLoginRoutes />
      </div>
      {showAdminChrome && <Footer />}
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
};

export default App;
